export default x => x;



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/identity.js
// module id = 99
// module chunks = 0